import { Component, OnInit } from '@angular/core';
import { BreadCrumb } from './../../models/common/bread-crumb';
import { HeaderService } from './../services/header.service';
import { SettingService } from '../../system-common/services/setting.service';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { BaseService } from '../services/base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'sym-system-settings',
  templateUrl: './system-settings.component.html',
  styleUrls: ['./system-settings.component.css'],
})
export class SystemSettingsComponent extends BaseComponent<BaseService> implements OnInit {
  public breadCrumbList: BreadCrumb[];
  public currentSelectedTheme: string;
  public selectedTheme: string;
  public baseURL;
  public enableFingerprintAuth: boolean = false;

  constructor(
    baseService: BaseService,
    public settingService: SettingService,
    public headerService: HeaderService,
    private http: HttpClient
  ) {
    super(baseService);
    this.currentSelectedTheme = this.settingService.getSessionStorageValue('currentSelectedTheme');
    this.getPageHeader();
  }

  public themeList = {
    data: {
      themeList: [
        { cd: 'default', desc: 'Default' },
        { cd: 'dark', desc: 'Dark' },
      ],
    },
  };

  ngOnInit() {
    super.ngOnInit();
    this.breadCrumbList = [];
    this.breadCrumbList = this.getBreadCrumbList();
    if (this.settingService.getApplicationMode() === 'offline') {
      const userCredentials = this.settingService.getURLValue('USERCREDENTIALS');
      if (userCredentials != undefined) {
        this.enableFingerprintAuth = userCredentials['enableFingerprintAuth'] === 'YES';
      }
    }
  }

  onSettingThemeSelect(themeName: string) {
    if (this.currentSelectedTheme != undefined) {
      this.settingService.removeExternalStyle(this.currentSelectedTheme);
    }

    this.saveDashboardTheme(themeName).subscribe((res) => {
      console.log('Theme save response:', res);
    });

    let cssFileName = themeName + '.css';
    if (themeName != 'default') {
      this.settingService.loadExternalStyle(cssFileName, 'assets/theme/css/skin');
    }

    if (themeName == 'metallic') this.settingService.isNewUIDisplayed = true;
    else this.settingService.isNewUIDisplayed = false;

    this.currentSelectedTheme = cssFileName;
    this.settingService.setSessionStorageValue('currentSelectedTheme', this.currentSelectedTheme);
  }

  private getPageHeader() {
    this.headerService.pageHeader = new PageHeader();
    this.headerService.pageHeader.title = 'System-Settings';
  }

  private getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'home',
        link: '/home',
      },
      {
        id: 'system-setting',
      },
    ];
  }

  async setBiometric(event: any) {
    const isChecked = event.target.checked;
    let body = {
      enableFingerprintAuth: isChecked ? 'YES' : 'NO',
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    try {
      let response = await this.http
        .post(`${this.settingService.getURLValue('MENU')}/securitySetting`, body, { headers })
        .toPromise();
      await this.settingService.load();
      console.log('API Response:', response);
    } catch (error) {
      console.error('Error setting biometric:', error);
    }
  }

  saveDashboardTheme(themeName: string) {
    let userLoginData;
    userLoginData = JSON.parse(sessionStorage.getItem('userLoginData'));
    if (themeName.toLocaleString() != 'dark') {
      let currentSelectedTheme = this.settingService.getSessionStorageValue('currentSelectedTheme');
      if (currentSelectedTheme != undefined) {
        this.settingService.removeExternalStyle(currentSelectedTheme);
        // this.settingService.loadExternalStyle(currentSelectedTheme, 'assets/theme/css/skin');
      }
    }
    let body = {
      userdashboardSeq: this.settingService.getSessionStorageValue('userdashboardSeq'),
      isRequired: themeName.toLocaleString() == 'dark' ? 'Y' : 'N',
      agentId: userLoginData.agentId,
    };
    return this.http.post('api/userdashboard/savedashboardtheme', body);
  }
}
